import * as React from "react";

export function useWindowSize() {
	const [windowSize, setWindowSize] = React.useState<{
		height: number | undefined;
		width: number | undefined;
	}>({
		height: undefined,
		width: undefined,
	});

	React.useEffect(() => {
		// only execute all the code below in client side
		// Handler to call on window resize
		const totalHeightOfBrowserChrome = window.outerHeight - window.innerHeight;

		const handleResize = () => {
			// Since window resize fires on scroll in mobile browsers (when browser
			// chrome is toggled), reacting on every resize would cause too frequent
			// updates. To work around, we only set height delta is larger than that
			// of the height delta of the browser chrome.
			const heightDeltaSinceLastSet = Math.abs(
				window.innerHeight - (windowSize.height ?? 0),
			);

			if (
				// Never bail if width changed
				windowSize.width === window.innerWidth &&
				heightDeltaSinceLastSet <= totalHeightOfBrowserChrome
			) {
				return;
			}

			// Set window width/height to state
			setWindowSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		// Add event listener
		window.addEventListener("resize", handleResize);

		// Call handler right away so state gets updated with initial window size
		handleResize();

		// Remove event listener on cleanup
		return () => window.removeEventListener("resize", handleResize);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return windowSize;
}
